import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { PDIchecklist } from '../app/fs/data/PDIchecklist';

const unitCategories = (headers) => {
	const headerCategories = headers.filter((header) => header.split(' > ').length > 1 && !header.endsWith('Details'));
	return headerCategories ? headerCategories.map(header => ({
		header,
		title: header.split(' > ')[1]
	})) : [];
};

export const unitProgress = (unitRow, headers) => {
	// console.log('headers', headers);
	if (!unitRow) return [];

	const groupedByCategory = _.groupBy(unitCategories(headers), 'title');
	// console.log('groupedByCategory', groupedByCategory);
	const progressByCategory = Object.entries(groupedByCategory).map(([title, categories]) => {
		const total = categories.length;

		const completed = categories.reduce((acc, category) => {
			const group = category.header.split(' > ')[0];
			const subGroup = category.header.split(' > ')[1];
			const subGroupHeader = category.header.split(' > ')[2];

			const skipItem = PDIchecklist.find(item => {
				return item.group === group && item.items.find(i => i.category === subGroup && i.items.find(ii => ii.name === subGroupHeader && ii.trackProgress === false));
			});

			// Ignore items where trackProgress === false from PDIchecklist.js and mark them as complete
			if (skipItem) {
				return acc + 1;
			};

			const value = unitRow.get(category.header);
			return acc + ((value === "Yes" || value === "N/A") ? 1 : 0);
		}, 0);

		return {
			title,
			progress: _.round(completed / total, 2)
		};
	});
	unitRow.categoryProgress = progressByCategory;
	return progressByCategory;
};

const SubNavCTA = props => {

	const toCamelCase = str => str.replaceAll(" ", '');

	const handleClick = e => {
		// e.preventDefault();
		// const target = e.target;
		// const id = target.getAttribute("href").replace("#", "");
		// const targetEl = document.querySelector(`#${ id }`);

		// if (targetEl) {
		// 	targetEl.scrollIntoView({
		// 		behavior: "smooth",
		// 		block: "start",
		// 		inline: "nearest"
		// 	})
		// }
	}

	return <>
		<a href={`#${ toCamelCase(props.title) }`} onClick={ handleClick } className="tw-text-inherit tw-transition-opacity tw-duration-500 tw-group">
			<span className="tw-flex-grow tw-opacity-70 group-hover:tw-opacity-100 group-hover:tw-duration-500 tw-duration-150">
				{ props.title }
			</span>
			<span className="tw-flex tw-justify-end tw-items-center tw-flex-shrink-0 tw-space-x-2px">
				<span className="tw=flex-shrink-0 tw-flex tw-items-center tw-text-[0.1em]">
					Status:
				</span>
				<span className="tw-bg-white/20 tw-border-1px tw-border-white/10 tw-flex-grow tw-flex tw-w-30px tw-h-5px">
					<span className={`tw-flex tw-w-full tw-max-w-[var(--max-w)] ${ props.progress > .9 ? 'tw-bg-lime-500' : (props.progress > .7 ? 'tw-bg-yellow-300' :  'tw-bg-red-300') }`} style={{ '--max-w': ( props.progress > 0 ? `${props.progress * 100}%` : '0%') }}>
						<span className={`tw-pt-5px`}>
							{ Math.round(props.progress * 100) }%
						</span>
					</span>
				</span>
			</span>
		</a>
	</>
}

const QCUnitStatus = ({subNavData}) => {

    return <ul className="tw-top-40px [&_a]:tw-flex [&_a]:tw-items-center [&_a]:tw-w-full [&_a]:tw-min-h-30px tw-uppercase tw-leading-none tw-text-[.8em] tw-min-w-150px tw-divide-y-1px tw-divide-white/20 tw-space-y-5px [&_>*+*]:tw-py-5px">
        { subNavData.map((item, index) => {
            return <li key={`subNavData_${ index }`}>
                <SubNavCTA title={ item.title } progress={ item.progress } />
            </li>
        }) }
    </ul>

}

export default QCUnitStatus
